import React from "react";
import { Form, Input, Button, Card, Tag, Typography } from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { defaultMilestones } from "./defaults";
import type { SectionMeta } from "./types";

const { Text } = Typography;

export const meta: SectionMeta = {
  key: "milestones",
  label: "Milestones",
  icon: <CalendarOutlined />,
  color: "#10b981",
  desc: "Company timeline and key achievements",
};

export const defaultData = defaultMilestones;

export const Preview: React.FC<{ data: any[] }> = ({ data }) => {
  if (data.length === 0) return null;
  return (
    <div className="space-y-1.5">
      {data.map((item: any, i: number) => (
        <div key={i} className="flex items-start gap-2 text-sm">
          <Tag
            color="green"
            className="!m-0 !min-w-[52px] text-center !text-xs !leading-5 !font-medium !px-1.5"
          >
            {item.year}
          </Tag>
          <div className="flex-1 min-w-0">
            <span className="font-medium text-gray-800">{item.title}</span>
            <Text type="secondary" className="text-xs block truncate">
              {item.description}
            </Text>
          </div>
        </div>
      ))}
    </div>
  );
};

export const FormFields: React.FC = () => (
  <Form.List name="milestones">
    {(fields, { add, remove }) => (
      <>
        {fields.map((field) => (
          <Card
            key={field.key}
            className="!mb-3"
            size="small"
            type="inner"
            extra={
              <Button
                type="text"
                danger
                size="small"
                onClick={() => remove(field.name)}
                icon={<DeleteOutlined />}
              />
            }
          >
            <div className="grid grid-cols-3 gap-3">
              <Form.Item
                {...field}
                name={[field.name, "year"]}
                label="Year"
                className="!mb-0"
                rules={[{ required: true, message: "Required" }]}
              >
                <Input placeholder="e.g. 2024" />
              </Form.Item>
              <Form.Item
                {...field}
                name={[field.name, "title"]}
                label="Title"
                className="!mb-0"
                rules={[{ required: true, message: "Required" }]}
              >
                <Input placeholder="e.g. Founded" />
              </Form.Item>
              <Form.Item
                {...field}
                name={[field.name, "description"]}
                label="Description"
                className="!mb-0"
                rules={[{ required: true, message: "Required" }]}
              >
                <Input.TextArea
                  rows={2}
                  placeholder="What happened this year?"
                />
              </Form.Item>
            </div>
          </Card>
        ))}
        <Button
          type="dashed"
          block
          onClick={() => add()}
          icon={<PlusOutlined />}
          className="!mb-1"
        >
          Add Milestone
        </Button>
      </>
    )}
  </Form.List>
);
